import React, { useState, useEffect } from 'react';

import { useTranslation } from 'react-i18next';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import IconButton from '@mui/material/IconButton';

import Tooltip from '@mui/material/Tooltip';

import logoDe from 'images/logo_de.png';
import logoEn from 'images/logo_en.png';

import * as S from './styled';

const ChangeLang = () => {
  const { i18n, t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [language, setLanguage] = useState<string>(i18n.language);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    setLanguage(i18n.language);
  }, [i18n.language]);

  const changeLanguage = (lng: string) => {
    if (i18n.language !== lng) {
      i18n.changeLanguage(lng);
    }
  };

  return (
    <>
      <Tooltip title={t('header.profile')}>
        <IconButton onClick={handleClick} sx={{ ml: 2 }}>
          {language === 'de' ? <S.Logo src={logoDe} alt="" /> : <S.Logo src={logoEn} alt="" />}
        </IconButton>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: 'visible',
            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
            mt: 1.5,
            '& .MuiAvatar-root': {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            '&:before': {
              content: '""',
              display: 'block',
              position: 'absolute',
              top: 0,
              right: 27,
              width: 10,
              height: 10,
              bgcolor: 'background.paper',
              transform: 'translateY(-50%) rotate(45deg)',
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        <MenuItem onClick={() => changeLanguage('en')}>
          <ListItemIcon>
            <S.Logo src={logoEn} alt="" />
          </ListItemIcon>
          {t('english')}
        </MenuItem>
        <MenuItem onClick={() => changeLanguage('de')}>
          <ListItemIcon>
            <S.Logo src={logoDe} alt="" />
          </ListItemIcon>
          {t('german')}
        </MenuItem>
      </Menu>
    </>
  );
};

export default ChangeLang;
